import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/apiClient';

const useMagicLogin = () => {
  return useMutation({
    mutationKey: ['magicLogin'],
    mutationFn: ({ magicLoginToken }: { magicLoginToken: string }) =>
      apiClient
        .post(`api/auth-ui/magic-login/exchange`, {
          json: { token: magicLoginToken },
          headers: {
            Authorization: undefined,
          },
        })
        .json<{ jwt: string }>(),
  });
};

export default useMagicLogin;
